import {
	Component,
	OnChanges,
	SimpleChanges,
	computed,
	input,
	output,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {
	GroupedSearchItemDto,
	SearchItemDto,
	SearchReferenceTypeEnum,
} from 'app/core/services/api.service';
import { Location } from '@angular/common';
import { QuickViewClaimComponent } from 'app/components/search-command-palette/quick-view-claim/quick-view-claim.component';
import { QuickViewCompanyComponent } from 'app/components/search-command-palette/quick-view-company/quick-view-company.component';
import { QuickViewContactComponent } from 'app/components/search-command-palette/quick-view-contact/quick-view-contact.component';
import { QuickViewLeadComponent } from 'app/components/search-command-palette/quick-view-lead/quick-view-lead.component';
import { QuickViewUserComponent } from 'app/components/search-command-palette/quick-view-user/quick-view-user.component';
import { Router } from '@angular/router';

@Component({
	selector: 'cm-search-dropdown-option',
	imports: [
		NgClass,
		MatIconModule,
		QuickViewClaimComponent,
		QuickViewCompanyComponent,
		QuickViewContactComponent,
		QuickViewLeadComponent,
		QuickViewUserComponent,
	],
	templateUrl: './search-dropdown-option.component.html',
})
export class SearchDropdownOptionComponent implements OnChanges {
	readonly results = input<GroupedSearchItemDto[]>([]);

	readonly onClose = output<any>();

	searchItemType: SearchReferenceTypeEnum;
	activeSearchType: SearchReferenceTypeEnum | 'All' = 'All';

	searchResultLength = computed(() => this.results()?.length);
	searchItems: SearchItemDto[];

	searchItem: SearchItemDto;
	searchResultItemLength = computed(() =>
		this.results()?.reduce((acc, curr) => acc + curr.items.length, 0)
	);

	constructor(private _router: Router, private _location: Location) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.hasOwnProperty('results')) {
			this.getSearchItems('All');
		}
	}

	getSearchItems(searchType: SearchReferenceTypeEnum | 'All') {
		const results = this.results() || [];
		this.activeSearchType = searchType;

		switch (searchType) {
			case 'All':
				this.searchItems = results.reduce(
					(acc, curr) => acc.concat(curr.items),
					[]
				);
				break;
			default:
				this.searchItems = results.find(
					(x) => x.referenceType === searchType
				).items;
				break;
		}
	}

	goToPage() {
		let currentUrl = this._location.path();
		let newUrl = this.searchItem.link;
		let currentUrlArray = currentUrl.split('/');
		let newUrlArray = newUrl.split('/');

		if (
			currentUrlArray[1] === newUrlArray[1] &&
			currentUrlArray.length === newUrlArray.length
		) {
			currentUrlArray.splice(0, 3);
			newUrl = `/${newUrlArray[1]}/${
				newUrlArray[2]
			}/${currentUrlArray.join('/')}`;
		}

		this._router
			.navigateByUrl('/pages/loading', {
				skipLocationChange: true,
			})
			.then(() => {
				this._router.navigateByUrl(newUrl);
			});

		this.onClose.emit(null);
	}

	onMouseEnter(searchItem: SearchItemDto) {
		this.searchItem = searchItem;
	}
}
